<template>
  <portal v-if="shouldBeOpen" to="MODAL" :order="key">
    <vk-modal
        :key="key"
        :has-close-icon="hasCloseIcon"
        @close="$emit('secondary')"
        class="SLIDING-MODAL-OVERLAY"
        :class="[
          backdropClass,
          {
            'HIDING': initiateHiding,
            'IGNORE-OPACITY': transitionName === 'SLIDE-RIGHT' }]">
      <transition :name="transitionName" appear @after-leave="onAfterLeave">
        <slot v-if="!initiateHiding" name="body">
          <vk-modal-body class="SLIDING-MODAL-BODY">
            <slot />
          </vk-modal-body>
        </slot>
      </transition>
    </vk-modal>
  </portal>
</template>

<script>
import _uniqueId from 'lodash/uniqueId';

export default {
  name: 'sliding-modal',
  props: {
    hasCloseIcon: {
      type: Boolean,
      default: false,
    },
    isOpen: Boolean,
    backdropClass: String,
    transitionName: {
      type: String,
      default: 'SLIDE-UP',
    },
  },
  data () {
    return {
      key: parseInt(_uniqueId(), 10),
      shouldBeOpen: this.isOpen,
      initiateHiding: false,
    };
  },
  watch: {
    isOpen () {
      if (this.isOpen) {
        this.shouldBeOpen = this.isOpen;
      } else {
        this.initiateHiding = !this.isOpen;
      }
    },
  },
  methods: {
    onAfterLeave () {
      if (this.initiateHiding) {
        this.shouldBeOpen = false;
        this.initiateHiding = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .SLIDING-MODAL-OVERLAY {
    @include responsive(align-items, flex-end, center);
    will-change: opacity;
    transition: opacity $transition-duration ease;

    &.HIDING {
      opacity: 0;
    }

    &.IGNORE-OPACITY {
      opacity: 1;
    }
  }

  .SLIDING-MODAL-BODY {
    @include responsive(min-width, 100%, auto);
    @include responsive(width, 100%, auto);
    @include responsive(max-width, 100%, none);
    min-height: auto;
    height: auto;
    max-height: none;
  }

  .SLIDE-UP-enter-active,
  .SLIDE-UP-leave-active {
    transform: none;
    will-change: transform;
    transition: transform $transition-duration;

    &.SLIDE-UP-enter,
    &.SLIDE-UP-leave-to {
      transform: translateY(100%);
    }
  }

  .SLIDE-RIGHT-enter-active,
  .SLIDE-RIGHT-leave-active {
    transform: none;
    will-change: transform;
    transition: transform $transition-duration;

    &.SLIDE-RIGHT-enter,
    &.SLIDE-RIGHT-leave-to {
      transform: translateX(100%);
    }
  }
</style>
